module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-to-up-c8c6523d60d6a4faf2d5628cefe87ba6.svg";